import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import ResaleIcon from '@wix/da-ds/pkg/Icons/16x16/Resale';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './ResaleIndicator.scss';
const ResaleIndicator = ({ isResellable, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], !isResellable && s['dim'], className)
    }, /*#__PURE__*/ React.createElement(ResaleIcon, {
        size: IconSize.SMALLER,
        role: "presentation"
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['text']
    }, t(isResellable ? 'sidebar.exclusives.resaleIndicator.allowed' : 'sidebar.exclusives.resaleIndicator.notAllowed')));
};
ResaleIndicator.displayName = 'ResaleIndicator';
export default ResaleIndicator;
